// Labels shared by the email log tab and its drawer. Status keys match the
// get-email-log-for-group request filter; colours are the app's success, info,
// danger and primary hues.

export const EMAIL_STATUS_LABELS: Record<string, string> = {
  sent: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  clicked: 'Clicked',
  delayed: 'Delayed',
  bounced: 'Bounced',
  complained: 'Complaint'
}

// SES event name to the status key the filters use
const EVENT_TO_STATUS: Record<string, string> = {
  Complaint: 'complained', Bounce: 'bounced', Click: 'clicked', Open: 'opened',
  DeliveryDelay: 'delayed', Delivery: 'delivered', Send: 'sent'
}
export function eventToStatus(eventType: string) {
  return EVENT_TO_STATUS[eventType] || 'sent'
}

export const EMAIL_EVENT_LABELS: Record<string, string> = {
  Send: 'Sent', Delivery: 'Delivered', Open: 'Opened', Click: 'Clicked',
  DeliveryDelay: 'Delayed', Bounce: 'Bounced', Complaint: 'Complaint', Reject: 'Rejected',
  RenderingFailure: 'Rendering failure', Subscription: 'Subscription change'
}

export const EMAIL_STATUS_COLORS: Record<string, string> = {
  sent: '#1d8cf8',
  delivered: '#00f2c3',
  opened: '#00f2c3',
  clicked: '#00f2c3',
  delayed: '#ffcc00',
  bounced: '#fd5d93',
  complained: '#fd5d93'
}

// Customer copy says event, the stored email_type keys say game
const EMAIL_TYPE_LABELS: Record<string, string> = {
  confirmation: 'Booking confirmation',
  reminder: 'Booking reminder',
  follow_up: 'Follow up',
  survey: 'Survey request',
  gift_card: 'Gift card delivery',
  receipt: 'Payment receipt',
  waiver: 'Waiver request',
  abandoned_cart: 'Abandoned cart',
  payment_request: 'Payment request',
  campaign: 'Marketing campaign'
}

function humanize(key: string) {
  return String(key || '').replace(/[_-]+/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}

// Template name when the email came from a template, else a plain label for the type key
export function emailLabel(row: any) {
  if (row.template_id && row.email_name) return row.email_name
  return EMAIL_TYPE_LABELS[row.email_type] || humanize(row.email_name || row.email_type)
}

// Where the email came from, in the product's own words:
// a marketing campaign, an advanced automation rule, a template sent directly from the
// console (a transaction page send or a test send), or one of the standard automated
// emails (confirmations, reminders, receipts) that carry no template at all
export function emailSourceLabel(row: any) {
  if (row.campaign_name) return 'Campaign: ' + row.campaign_name
  if (row.automation_name) return 'Automation: ' + row.automation_name
  if (row.template_id) return 'Sent from the console'
  return 'Standard automated email'
}
